import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CONFIG } from '../../core/config/config.token';

@Injectable({
  providedIn: 'root',
})
export class ApiService {
  private readonly config = inject(CONFIG);
  private readonly apiUrl = this.config.api_url;
  private static readonly headersJson = new HttpHeaders({
    'Content-Type': 'application/json',
    accept: 'application/json',
  });

  constructor(private readonly http: HttpClient) {}

  get<T>(url: string, params?: HttpParams): Observable<T> {
    const headers = ApiService.headersJson;
    return this.http.get<T>(`${this.apiUrl}${url}`, { headers, params });
  }

  post<T>(url: string, body: any, params?: HttpParams): Observable<T> {
    const headers = ApiService.headersJson;
    return this.http.post<T>(`${this.apiUrl}${url}`, body, { headers, params });
  }

  put<T>(url: string, body: any, params?: HttpParams): Observable<T> {
    const headers = ApiService.headersJson;
    return this.http.put<T>(`${this.apiUrl}${url}`, body, { headers, params });
  }
}
